export default __webpack_public_path__ + "static/media/img-0592-poland-half-face.f9aa02ee.png";